import {getYPositionFromValue, getXPositionFromStep} from './position.js';
import Tone from 'tone';
import { createSelector } from 'reselect';


const getWidth = (state) => state.width;
const getHeight = (state) => state.height;
const getSelectedParameter = (state) => state.selectedParameter;
const getXScale = (state) => state.xScale;
const getEvents = (state) => state.events;

export const getLinePoints = 
    createSelector(
        [getWidth, getHeight, getSelectedParameter, getXScale, getEvents],
        (width, height, parameter, xScale, events) =>
            _getLinePoints(width, height, parameter, xScale, events));

const _getLinePoints = (width, height, selectedParameter, xScale, events) => {
    if (selectedParameter === undefined) {
        return [];
    }
    let pts = []; 
    if (events.length === 0 || events[0] === undefined) {
        let value = selectedParameter.toFrequency ?
            selectedParameter.toFrequency() :
            selectedParameter.get();
        if (selectedParameter.getNumberFromOption) {
            value = selectedParameter.getNumberFromOption(value);
        }
          
        let startY = getYPositionFromValue(
            value,
            height,
            selectedParameter.min,
            selectedParameter.max);
        pts = [0, startY];
    } else {
        pts = [0, getYPositionFromValue(
            events[0].value,
            height,
            selectedParameter.min,
            selectedParameter.max)];
    }

    for (let i in events) {
        let x = getXPositionFromStep(events[i].step, xScale, width);
        let value = events[i].value === undefined ? selectedParameter.get(true) : events[i].value;
        pts.push(x);
        pts.push(getYPositionFromValue(
            events[i].value,
            height,
            selectedParameter.min,
            selectedParameter.max,
        ));
    }
    
    let lastX = pts[pts.length - 2];
    let lastY = pts[pts.length - 1];
    
    pts.push(width);
    pts.push(lastY);
    return pts;

};

